import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Column,
  Heading,
  Row,
  SkeletonLoader,
  Button,
} from '@chargify/custom-ui-components';
import { CouponsList } from '../../components/CouponsList/CouponsList';
import { useComponentSettings, useServices } from '../../hooks/index';
import { useSelector } from '@xstate/react';
import { Currency } from '@chargify/formatters';
import { formatCouponValue, getCouponDescription } from './utils';
import { subscriptionSelectors } from '../../machines';
import { SubscriptionDetailsMachineInterpreter } from '../../machines/subscription/types';

type Props = {
  subscriptionId: number;
  catalogId: number;
  currency: Currency;
  subscriptionDetailsService: SubscriptionDetailsMachineInterpreter;
};
const CouponsContainer = ({
  subscriptionId,
  catalogId,
  currency,
  subscriptionDetailsService,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  const { modalsService } = useServices();
  const { subscription } = useComponentSettings();
  const allowAddCoupon = subscription.coupons;
  const coupons = useSelector(
    subscriptionDetailsService,
    subscriptionSelectors.getCoupons
  );

  const { isLoading } = useSelector(
    subscriptionDetailsService,
    subscriptionSelectors.getCouponsStatus
  );

  const formattedCoupons = coupons?.map((coupon) => ({
    code: coupon.code,
    value: formatCouponValue(coupon, currency),
    description: getCouponDescription(coupon, t),
  }));

  const handleAddCouponClick = () => {
    modalsService.send({
      type: 'SHOW_ADD_COUPON',
      subscriptionId,
      catalogId,
      subscriptionDetailsService,
      currency,
    });
  };

  return (
    <>
      <Row data-testid="couponsContainer">
        <Column span={[24, 7]}>
          <Heading variant="h4">{t('coupons.discounts')}</Heading>
        </Column>
        <Column span={[24, 17]}>
          {isLoading ? <SkeletonLoader height={120} /> : null}
          {formattedCoupons?.length > 0 ? (
            <CouponsList coupons={formattedCoupons} />
          ) : null}
          {allowAddCoupon ? (
            <Button
              color="secondary"
              label={t('coupons.add_coupon')}
              onClick={handleAddCouponClick}
            />
          ) : null}
        </Column>
      </Row>
    </>
  );
};
export default CouponsContainer;
